import { NgModule } from '@angular/core';
import { ComponentsModule } from '@common/components/components.module';
import { DashboardViewComponent } from './views/dashboardView/dashboardView.component';
import { ServicesModule } from '@common/services/services.module';
import { CircleIndicatorComponent } from '@modules/dashboard/views/dashboardView/CircleIndicatorComponent/circleIndicator.component';
import { CommonModule } from '@angular/common';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    DashboardViewComponent,
    CircleIndicatorComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    TranslateModule,
    ServicesModule,
    RoundProgressModule,
  ],
  exports: [],
})
export class DashboardModule {}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.module.ts